import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { WIDGET_TYPES, WidgetContent } from 'site-modules/shared/components/native-ad/my-finance-widget/widget-content';
import { UsurpAd } from 'site-modules/shared/components/native-ad/srp-ad/usurp-ad';
import { Experiment, Recipe } from 'site-modules/shared/components/experiment';

function UsurpMyWidgetUI({
  usPrivacy = null,
  doNotSell = false,
  wrapperTag: WrapperTag = 'li',
  wrapperTagClassName = 'mb-0_75 mb-md-1_5 col-12 col-md-6',
  wrapperAdComponentClassName = 'usurp-inventory-card rounded-12 overflow-hidden h-100 w-100 bg-white',
  location = {},
  zipCode = null,
  ...restProps
}) {
  if (usPrivacy === '1YYN' || doNotSell) {
    return (
      <UsurpAd
        wrapperTag={WrapperTag}
        wrapperTagClassName={wrapperTagClassName}
        wrapperAdComponentClassName={wrapperAdComponentClassName}
        {...restProps}
      />
    );
  }

  return (
    <Experiment name="ads-12586" showDefault key="srp-retention-15">
      <Recipe name="ctrl" isDefault>
        <UsurpAd
          wrapperTag={WrapperTag}
          wrapperTagClassName={wrapperTagClassName}
          wrapperAdComponentClassName={wrapperAdComponentClassName}
          {...restProps}
        />
      </Recipe>
      <Recipe name="chal">
        <WrapperTag className={wrapperTagClassName} style={{ height: '622px' }}>
          <WidgetContent
            widgetType={WIDGET_TYPES.ZIP_WIDGET_B}
            location={location}
            zipCode={zipCode}
            widgetClassName={classnames('m-0', wrapperAdComponentClassName)}
          />
        </WrapperTag>
      </Recipe>
    </Experiment>
  );
}

UsurpMyWidgetUI.propTypes = {
  usPrivacy: PropTypes.string,
  doNotSell: PropTypes.bool,
  wrapperTagClassName: PropTypes.string,
  wrapperAdComponentClassName: PropTypes.string,
  location: PropTypes.shape({}),
  zipCode: PropTypes.string,
};

export const mapStateToProps = state => ({
  usPrivacy: state.visitor?.privacy?.uspString,
  doNotSell: state.visitor?.privacy?.doNotSell,
  location: state.pageContext?.location,
  zipCode: state.visitor?.location?.zipCode,
});

export const UsurpMyWidget = connect(mapStateToProps)(UsurpMyWidgetUI);
